import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import { IUserTypesResponse } from "../../../../../Types/SurveyFormsTypes";
import { surveyFormsService } from "../../../../../Api/Services/SurveyFormsService";

/**
 * Async thunk to fetch user types.
 */
export const fetchUserTypes = createServiceAsyncThunk<IUserTypesResponse, void>(
  ACTION_NAMES.FETCH_USER_TYPE_LIST,
  () => surveyFormsService.fetchUserTypeList(),
  ERROR_MESSAGES.FETCH_USER_TYPE_LIST_FAILURE
);

/**
 * Slice for user types
 */
const userTypesSlice = createGenericSlice<IUserTypesResponse, void>(
  SLICE_NAMES.USER_TYPE_LIST,
  fetchUserTypes
);

export const {
  clearError: clearUserTypesError,
  clearSuccessMessage: clearUserTypesSuccess,
} = userTypesSlice.actions;

export default userTypesSlice.reducer;
